export const LOAD_TOLLS_FILTERS = '[ACTIVITY_TOLLS_FILTERS]: Load tolls filters';
export const UPDATE_TOLLS_FILTERS = 'ACTIVITY_TOLLS_FILTERS]: Update tolls filters';
